import { get } from 'axios';
import { check as checkFF } from '@webapp-next/lib/feature-flag';
import { loadZendeskWidget } from './zendesk-widget';

let _hasChatSupport = false;
let _fetchChatSupportPromise = null;

async function loadSupportAccess() {
  if (!checkFF('wo-0-support-workflow-2')) {
    return true;
  }

  const isOnce = !window.$dt;

  if (isOnce) {
    return true;
  }

  if (!_fetchChatSupportPromise) {
    _fetchChatSupportPromise = get('/api/v1/my/setup/supportAccess');
  }

  return (await _fetchChatSupportPromise).data?.hasChatSupportAccess;
}

async function initializeSupportAccess() {
  if (await loadSupportAccess()) {
    loadZendeskWidget();
    _hasChatSupport = true;
    return;
  }
}

export default {
  initializeSupportAccess,
  loadSupportAccess,
};
